module.exports = __webpack_public_path__ + "static/media/women-stock-photo.a657a2cc.webp";